import { useState, useEffect, useRef } from "react";
import { Link } from "@/components/common/Link";
export default function FeaturedTechnologyCBrace() {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) setVisible(true);
    }, {
      threshold: 0.1
    });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);
  return <section style={{
    backgroundColor: "rgb(245, 244, 241)",
    backgroundPosition: "0% 0%",
    backgroundRepeat: "repeat",
    color: "rgb(26, 26, 26)",
    fontFamily: "Inter, system-ui, -apple-system, sans-serif",
    animation: "none 0s ease 0s 1 normal none running",
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gridTemplateRows: "auto"
  }} className="w-full grid-cols-1 md:grid-cols-2">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@400;500;600&family=Inter:wght@300;400;600&display=swap');
        .cbrace-section {
          display: grid;
        }
        @media (min-width: 768px) {
          .cbrace-section {
            grid-template-columns: 960px 960px;
            grid-template-rows: 552.5px;
          }
        }
        @media (max-width: 767px) {
          .cbrace-section {
            grid-template-columns: 100%;
            grid-template-rows: auto auto;
          }
        }
        .cbrace-qualify-link {
          color: rgb(229, 31, 38);
          font-family: Inter, system-ui, -apple-system, sans-serif;
          font-size: 14px;
          font-weight: 600;
          line-height: 20px;
          letter-spacing: 0.35px;
          text-decoration: none;
          transition: color 0.2s cubic-bezier(0.4, 0, 0.2, 1);
          cursor: pointer;
        }
        .cbrace-qualify-link:hover {
          color: rgb(180, 20, 26);
        }
      `}</style>

      <div className="cbrace-section w-full" style={{
      display: "contents"
    }}>
        <div className="relative overflow-hidden" style={{
        minHeight: "auto"
      }}>
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1684748/img/c_brace_detail.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1684748/img/c_brace_detail.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1684748/img/c_brace_detail.png-wvc-sizes" alt="Close-up of a modern carbon-fiber microprocessor knee orthosis on a patient's leg mid-stride inside a physical therapy clinic" className="w-full h-auto md:h-full" loading="lazy" decoding="async" style={{
          objectFit: "cover",
          objectPosition: "center",
          display: "block"
        }} />
        </div>

        <div ref={ref} className={`flex items-center transition-all duration-700 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
        backgroundColor: "rgb(245, 244, 241)",
        padding: "80px"
      }}>
          <div className="w-full">
            <p style={{
            fontFamily: "Inter, system-ui, -apple-system, sans-serif",
            fontSize: "11px",
            fontWeight: "600",
            letterSpacing: "0.15em",
            color: "rgb(229, 31, 38)",
            textTransform: "uppercase",
            marginBottom: "14px"
          }}>
              FEATURED TECHNOLOGY
            </p>

            <h2 style={{
            color: "rgb(26, 26, 26)",
            fontFamily: '"Cormorant Garamond", Georgia, serif',
            fontSize: "36px",
            fontWeight: "400",
            lineHeight: "45px",
            letterSpacing: "-0.9px",
            border: "0px solid rgb(26, 26, 26)",
            animation: "none 0s ease 0s 1 normal none running",
            marginBottom: "22px"
          }}>
              The C-Brace: microprocessor bracing that adapts to every step.
            </h2>

            <p style={{
            color: "oklch(0.446 0.03 256.802)",
            fontFamily: "Inter, system-ui, -apple-system, sans-serif",
            fontSize: "16px",
            fontWeight: "300",
            lineHeight: "26px",
            border: "0px solid oklch(0.446 0.03 256.802)",
            animation: "none 0s ease 0s 1 normal none running",
            marginBottom: "22px"
          }}>
              The C-Brace is a sensor-driven stance-and-swing-controlled knee ankle foot orthosis that responds to your movement in real time — supporting stair descent, slopes, and uneven terrain with stability. For patients with quadriceps weakness, post-polio syndrome, or neurological gait dysfunction, the C-Brace restores confident ambulation where conventional bracing falls short.
            </p>

            <Link to="#" className="cbrace-qualify-link" style={{
            color: "rgb(229, 31, 38)",
            fontFamily: "Inter, system-ui, -apple-system, sans-serif",
            fontSize: "14px",
            fontWeight: "600",
            lineHeight: "20px",
            letterSpacing: "0.35px",
            border: "0px solid rgb(229, 31, 38)",
            animation: "none 0s ease 0s 1 normal none running"
          }}>
              See if you qualify →
            </Link>
          </div>
        </div>
      </div>
    </section>;
}